<section
  class="hero"
  [ngStyle]="{ 'background-image': 'url(' + content.url + ')' }"
>
  <div class="hero-copy">
    <h1 [ngStyle]="{ color: content.color }">
      <b>{{ content.title }}</b>
    </h1>
    <h2 [ngStyle]="{ color: content.color }">
      <b>{{ content.body }}</b>
    </h2>
  </div>
</section>
